import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";
import { Link, useLocation, useParams } from "react-router-dom";
import { MdStar } from "react-icons/md";
import Header from "../Header/Header";
import Menu from "../Manu/Menu";
import { Helmet } from "react-helmet";
import Slider from "../Slider/Slider";
import TestimonialSlider from "../Slider/TestimonialSlider";
import TopRentedBlogs from "../Blog/TopRentedBlogs";
import FAQ from "../Blog/FAQ";
import CorporateCustomers from "../Blog/CorporateCustomers";
import Footer from "../Footer/Footer";
import Login_popup_2 from "../Login/Login_popup_2";
import { useTranslation } from "react-i18next";
import StickyBottomNav from "../StickyBottomNav/StickyBottomNav";
import NoZoomWrapper from "../../utils/NoZoomWrapper";
import "../../assets/css/Index.css";
import "../../assets/css/Menu.css";
import "../../assets/css/Header.css";
import "../../assets/css/Filter.css";
import "../../assets/css/ProdouctCloth.css";
import "../../assets/css/Slider.css";
import "../../assets/css/Add_click.css";
import "../../assets/css/Preview_Ad.css";
// import "../../assets/css/My_add.css";
import "../../assets/css/Edit.css";
import "../../assets/css/Edit_2.css";
// import "../../assets/css/Edit_Hello_User.css";
import "../../assets/css/Password.css";
import "../../assets/css/Add_Product.css";
import "../../assets/css/Footer.css";
import "../../assets/css/Login_1.css";

import "../../assets/css/Login_popup_2.css";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "../../assets/css/CategoryPage.css";
import "../../assets/css/LocationSelector.css";
import "../../assets/css/My_ads.css";
import "../../assets/css/Contact_Us.css";
import "../../assets/css/LanguaheSelectior.css";
import InstallPrompt from "../../utils/InstallPrompt";
import NoCopyWrapper from "../../utils/NoCopyWrapper";
import { useNavigate } from "react-router-dom";
// import banner from "../../assets/img/Why-BuyJust-Rent-(2).png";
import appStoreImg from "../../assets/img/appstore.png"
import playStoreImg from "../../assets/img/playstor.png"
import banner2 from "../../assets/img/Why-BuyJust-Rent-(9).png"
/* ================= CONFIG ================= */
const API_BASE = "https://network.rentel.in";

/* ================= UTILS ================= */
const slugify = (text = "") =>
  text
    .toString()
    .toLowerCase()
    .trim()
    .replace(/\s+/g, "-")
    .replace(/[^\w\-]+/g, "")
    .replace(/\-\-+/g, "-");

const calculateDiscountedPrice = (price, discount) =>
  !discount ? price : price - (price * discount) / 100;

/* ================= COMPONENT ================= */
const Index = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const handleUnauthorized = () => {
    alert("Session expired. Please login again.");
    localStorage.clear();
    window.location.reload();
  };


  const [products, setProducts] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [showLogin, setShowLogin] = useState(false);
  const [isLoading, setIsLoading] = useState(false);


  /* ================= QUERY PARAMS ================= */
  const queryParams = useMemo(
    () => new URLSearchParams(location.search),
    [location.search]
  );


  const pid = queryParams.get("pid");

  // ✅ SCROLL TO TOP ON PAGE LOAD
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  /* ================= LOGIN CHECK ================= */
  useEffect(() => {
    const user = localStorage.getItem("user");
    const token = localStorage.getItem("token");
    if (!user || !token) {
      const timer = setTimeout(() => setShowLogin(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  /* ================= FETCH PRODUCTS ================= */
  useEffect(() => {
    if (pid) return; // 🔥 if pid exists → skip listing

    const fetchProducts = async () => {
      setIsLoading(true);
      try {
        const query = new URLSearchParams();

        ["minPrice", "maxPrice", "categoryId", "location"].forEach((key) => {
          const value = queryParams.get(key);
          if (value) query.append(key, value);
        });

        const subCategory = queryParams.get("subCategory");
        if (subCategory) query.append("subCategory", subCategory.toLowerCase());

        const res = await axios.get(
          `${API_BASE}/products/get-user-products?${query.toString()}`
        );

        setProducts(res.data?.products || []);
      } catch (err) {
        if (err.response?.status === 401) {
          handleUnauthorized();
          return;
        }
        console.error("Fetch products failed", err);
      }
      finally {
        setIsLoading(false);
      }
    };

    fetchProducts();
  }, [queryParams, pid]);

  /* ================= PID REDIRECT ================= */
  useEffect(() => {
    if (!pid) return;

    const redirectByPid = async () => {
      setIsLoading(true);
      try {
        const res = await axios.get(
          `${API_BASE}/products/get-user-products?productId=${pid}`
        );

        const product =
          res.data?.product ||
          res.data?.products?.find((p) => p._id === pid);

        if (!product) return;

        navigate(
          `/${slugify(product.category)}/${slugify(
            product.subCategory
          )}/${slugify(product.title)}/${product._id}`,
          { replace: true }
        );
      } catch (err) {
        console.error("PID redirect failed", err);
      } finally {
        setIsLoading(false);
      }
    };

    redirectByPid();
  }, [pid, navigate]);

  /* ================= FILTER ================= */
  const filteredProducts = useMemo(
    () =>
      products.filter((p) =>
        p.title?.toLowerCase().includes(searchQuery.toLowerCase())
      ),
    [products, searchQuery]
  );




  return (
    <>
      <Helmet>
        <meta
          name="description"
          content="Rent clothes, electronics, vehicles & more on Rentel."
        />
      </Helmet>
      {/* Loader Overlay for API calls */}
      {isLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(173, 173, 173, 0.65)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              display: "flex",
              gap: "10px",
              alignItems: "center",
            }}
          >
            {[0, 1, 2, 3, 4].map((index) => (
              <div
                key={index}
                style={{
                  width: "12px",
                  height: "12px",
                  borderRadius: "50%",
                  backgroundColor: "#E91E63",
                  animation: `bounce 1.4s ease-in-out ${index * 0.2}s infinite both`,
                }}
              />
            ))}
          </div>
          <style>
            {`
              @keyframes bounce {
                0%, 80%, 100% {
                  transform: scale(0);
                  opacity: 0.5;
                }
                40% {
                  transform: scale(1);
                  opacity: 1;
                }
              }
            `}
          </style>
        </div>
      )}
      <InstallPrompt />
      <NoZoomWrapper>
        <NoCopyWrapper>
          <Header onSearchChange={setSearchQuery} />
          <Slider />
          <Menu />

          <div className="container">
            {/* <div className="product-grid">
              {products.length > 0 ? (
                filteredProducts.slice(0, visibleCount).map((item) => (
                  <div className="product-card" key={item._id}>
                    <div className="image-container">
                      <Link
                        to={`/${slugify(item.category)}/${slugify(
                          item.subCategory
                        )}/${slugify(item.title)}/${item._id}`}
                      >
                        <img
                          src={item.images?.[0] || "/fallback.jpg"}
                          alt={item.title}
                          loading="lazy"
                          width={300}
                          height={300}
                        />
                      </Link>

                      <div className="rating-badge-co">
                        <div className="rating-badgel">
                          <MdStar />
                          <h3>{item.averageRating}</h3>
                        </div>
                      </div>
                    </div>

                    <div className="all-item">
                      <p className="originale-priceo">
                        {`${item.userId?.name || ""} ${item.userId?.lastName || "Unknown Seller"}`}
                      </p>
                      <div className="sprat">
                        <h3>{item.title}</h3>
                      </div>
                      <p className="price-discounti">
                        <span className="final-priceoe">
                          ₹
                          {calculateDiscountedPrice(
                            item.price,
                            item.discount
                          ).toLocaleString("en-IN")}
                        </span>
                        {item.discount > 0 && (
                          <>
                            |
                            <span className="discounte">
                              {item.discount}% OFF
                            </span>
                          </>
                        )}
                      </p>
                    </div>
                  </div>
                ))
              ) : (
                <p>{t("no_products_found")}</p>
              )}
            </div> */}
            <div className="rent-banner-wrapper">
              <div className="rent-bannerff">
                <div className="rent-bannerff-text">
                  <h2>Give on Rent</h2>
                  <p>
                    List your freelancing services or spare items on Rentel – Start earning today
                  </p>
                </div>

                <buttons className="rent-bannerff-btn">
                  List Your Product
                </buttons>
              </div>
            </div>
            <TestimonialSlider />
            {/* <TopRentedBlogs /> */}
            <FAQ limit={6} showLayout={false} />
            {/* <CorporateCustomers /> */}

            {/* ===== DESKTOP BANNER ===== */}
            <div className="rent-banner desktop-banner">
              <div className="inside-banner">
                <div className="rent-overlay">
                  <div className="rent-text">
                    <h2>
                      Why Buy?
                      <br />
                      Just Rent!
                    </h2>
                  </div>

                  <div className="rent-divider"></div>

                  <div className="rent-right">
                    <p>Download on Android & iOS</p>

                    <div className="store-index-buttons">
                      <a href="https://apps.apple.com/in/app/rentel-rent-smart-live-better/id6744444463" target="_blank"> <img src={appStoreImg} alt="App Store" /></a>
                      <a href="https://play.google.com/store/apps/details?id=com.rent.el.in" target="_blank"> <img src={playStoreImg} alt="Play Store" /></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* ===== MOBILE BANNER ===== */}
            <div className="mobile-bannera">
              <img src={banner2} alt="Banner" className="don2" />

              <div className="rent-overlay-mobile">
                <h2>
                  Why Buy?
                  <br />
                  Just Rent!
                </h2>

                <p>Download on Android & iOS</p>

                <div className="store-buttonsh">
                  <a href="https://apps.apple.com/in/app/rentel-rent-smart-live-better/id6744444463" target="_blank"><img src={appStoreImg} alt="App Store" className="isoapp" /></a>
                  <a href="https://play.google.com/store/apps/details?id=com.rent.el.in" target="_blank"><img src={playStoreImg} alt="Play Store" className="isoapp" /></a>
                </div>
              </div>
            </div>




            <Login_popup_2
              show={showLogin}
              onClose={() => setShowLogin(false)}
              onSuccess={() => setShowLogin(false)}
            />
          </div>
          <StickyBottomNav />
          <Footer />
        </NoCopyWrapper>
      </NoZoomWrapper>
    </>
  );
};

export default Index;
